<template>
  <div>
    <!-- Tähän voit lisätä sisältöä -->

    <!-- Lisää child-komponentit tähän -->
    <VideowallDesktop v-if="isDesktop" />
    <VideowallMobile v-else-if="!isIOSNativeApp" />
  </div>
</template>

<script>
import VideowallDesktop from "@/components/Videowall-desktop.vue";
import VideowallMobile from "@/components/Videowall-mobile.vue";

export default {
  name: "ParentKomponentti",
  components: {
    VideowallDesktop,
    VideowallMobile
  },
  data() {
    return {
      isDesktop: window.innerWidth >= 800,
      isIOSNativeApp:
        /(iPod|iPhone|iPad)/.test(navigator.userAgent) && !window.MSStream
    };
  },
  created() {
    // Tarkista näytön leveys ja päivitä isDesktop-muuttuja tarvittaessa
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    // Poista kuuntelija kun komponentti tuhotaan
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // Päivitä isDesktop-muuttuja näytön leveyden perusteella
      this.isDesktop = window.innerWidth >= 800;
    }
  }
};
</script>

<style scoped>
/* Tähän voit lisätä tyylit */
</style>



// WEBPACK FOOTER //
// src/components/Videowall.vue